import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ProjectCard from '../shared-components/ProjectCard';

const Projects = ({
    projects,
    projectId,
    setProjectId,
    setProjectKey,
    setProjectMeasureType,
    setNickname
}) => {
    const [hide, setHide] = useState(false);

    return (
        <Accordion defaultExpanded sx={{ my: '10px' }}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                onClick={() => setHide(!hide)}
            >
                <Typography>{hide ? "Expand" : "Collapse"} Projects</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container sx={{ gap: 3 }}>
                    <Grid item xs={12} display="flex" alignContent={'space-between'} flexWrap={'wrap'} pb={1}>
                        <ProjectCard projects={projects} projectId={projectId} setProjectId={setProjectId}
                            setProjectKey={setProjectKey} setProjectMeasureType={setProjectMeasureType} setNickname={setNickname}
                            variant={'main'} />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default Projects